import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'expand',
  props: {
    expand: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    expand?: boolean
}



return { __sfc: true,props }
}

})